import styled, { keyframes } from 'styled-components'
import { darkTheme} from '../utils/Theme'
import Button from "./button"
import React from 'react'
import {AddRounded, ExploreRounded} from "@mui/icons-material";
import NeonButton from './neon'



import { useNavigate, useLocation } from 'react-router-dom';

const Container  = styled.div`
    flex: 1;
    background: ${({theme}) => theme.bg};
    color: ${({theme}) => theme.primary_color};
    font-weight: bold;
    font-size: 22px;
    padding: 14px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${({theme}) => theme.border};
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
    @media only screen and (max-width: 600px) {
        padding: 10px 12px;
    }
    `;




const Navbar = () => {
    const  navigate = useNavigate()
    const location = useLocation();
    const path = location.pathname.split("/");
  return (
    <Container>
        <span style={{color: "#fffce1"}}>NexArt</span>
        {
            path[1] === 'post' ?  (
            <Button
            onClick={() => navigate('/')} 
            text ="Explore Posts" 
            leftIcon={
                <ExploreRounded 
                    style={{
                        fontSize: "18px",
                    }}     
                />               
            }
            type = "secondary"       
        />
        ) : (
            <Button
            onClick={() => navigate('/post')} 
            text ="Create new post" 
            leftIcon={
                <AddRounded 
                    style={{
                        fontSize: "18px",
                        color: "#fffce1",
                    }}     
                />               
            }       
        />)}

    </Container>
  )
}

export default Navbar


